import React from "react";
import Typist from "react-typist";
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";

const MainBody = React.forwardRef(
	({ gradient, title, message, icons }, ref) => {
		return (
			<Jumbotron
				fluid
				id="home"
				style={{ background: `linear-gradient(136deg, ${gradient})`, backgroundSize: "1200% 1200%" }}
				className="title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
			>
				<div id="stars"></div>
				<Container className="text-center" style={{ zIndex: 1 }}>
					<h1 style={{ fontFamily: ['Montserrat', 'sans-serif'], fontWeight: 500 }} ref={ref} className="display-2">{title}</h1>
					<Typist style={{ fontFamily: ['Montserrat', 'sans-serif'], fontWeight: 500 }} className="lead typist h3">{" "}{message}</Typist>
					<div className="p-5">
						{icons.map((icon, index) => (
							<a
								key={`social-icon-${index}`}
								target="_blank"
								rel="noopener noreferrer"
								href={icon.url}
								aria-label={`My ${icon.image.split("-")[1]}`}
							><i className={`fab ${icon.image} fa-3x socialicons`} /></a>
						))}
					</div>
					<i style={{ left: 0, bottom: 0, marginBottom: '3%' }} className="fa fa-chevron-down fa-4x position-absolute text-center w-100" />
				</Container>
			</Jumbotron>
		);
	}
);

export default MainBody;